import PropTypes from "prop-types";

import { overlayMutate, useOverlayOptionId } from "src/pages/Designs/overlay";
import { TagAttributesModalLayout } from "./TagAttributesModal.layout";
import { useTagAttributeForm } from "./useTagAttributeForm";
import { useTagAttributeSave } from "./useTagAttributeSave";

const TagAttributesModal = (props) => {
  const overlayOptionId = useOverlayOptionId();
  const form = useTagAttributeForm(props);
  const save = useTagAttributeSave({
    form,
    ...props,
    overlayOptionId,
    overlayMutate,
  });
  return <TagAttributesModalLayout {...props} {...form} {...save} />;
};

TagAttributesModal.propTypes = {
  onClose: PropTypes.func,
  entityTag: PropTypes.object,
  tagTypeConfig: PropTypes.object,
  isNewTag: PropTypes.bool,
  setNewTag: PropTypes.func,
  comments: PropTypes.object,
  entityId: PropTypes.string,
  tagTypes: PropTypes.arrayOf(PropTypes.string),
  tagsQueryTagTypes: PropTypes.arrayOf(PropTypes.string),
  featureFlags: PropTypes.object,
  tagTypesConfig: PropTypes.array,
  editMode: PropTypes.bool,
  readOnly: PropTypes.bool,
  entityType: PropTypes.string,
  onTagUpdated: PropTypes.func,
};

export default TagAttributesModal;
